import { render, staticRenderFns } from "./Recursos.vue?vue&type=template&id=1e075b0d&"
import script from "./Recursos.vue?vue&type=script&lang=js&"
export * from "./Recursos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports